/**
 * Clamp number between a lower and upper bound
 * @param number Target number
 * @param lower Lower bound
 * @param upper Upper bound
 */
export function clamp(number: number, lower: number, upper: number): number {
	return Math.min(Math.max(number, lower), upper)
}
